import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import {
  DynamicForm,
  LoggerFactory,
  Schema,
  SecurityProvider
} from "lego-gui-lib";
import { FlatForm } from "lego-gui-lib/lib/components/Views/ShowView/FlatForm";
import { observer } from "mobx-react-lite";
import React, {
  ReactText,
  SyntheticEvent,
  useContext,
  useEffect,
  useState
} from "react";
import { Form, FormRenderProps } from "react-final-form";
import { FormState } from "final-form";
import { useTranslation } from "react-i18next";
import { DialogContentContainer } from "../../../../common/dialogContainers";
import { treeBlockContext } from "../schema";
import { BlockObject } from "../treeBlockOutputsDataSource";
import { runInAction } from "mobx";

const log = LoggerFactory.create("ShowTreeBlockView");

interface ShowTreeBlockProps {
  customAction?: any;
  schema: Schema;
  treeBlockId: ReactText;
  handleRefreshBlock: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      minWidth: "80px",
      maxHeight: "30px",
      marginLeft: theme.spacing(2)
    },
    buttonContainer: {
      marginTop: theme.spacing(3),
      justifyContent: "flex-end",
      display: "flex",
      width: "100%"
    }
  })
);

export const ShowTreeBlockView = observer((props: ShowTreeBlockProps) => {
  const { schema, customAction, treeBlockId } = props;
  const classes = useStyles();
  const i18n = useTranslation();
  const buttonText = i18n.t("common:save");
  const treeBlockDataSource = useContext(treeBlockContext);

  const [block, setBlock] = useState<BlockObject | undefined>();

  useEffect(() => {
    const localBlock = treeBlockDataSource.treeStructure.blocks.find(
      (b: BlockObject) => b.id === treeBlockId
    );
    runInAction(() => {
      treeBlockDataSource.oneDataSource.one = localBlock;
    });
    setBlock(localBlock);
  }, [treeBlockDataSource.treeStructure.blocks, treeBlockId]);

  const submit = async (values: any): Promise<void> => {
    log.debug("submit");
    await treeBlockDataSource.updateTreeBlock(values, treeBlockId);
    props.handleRefreshBlock();
  };

  const changed = (formState: FormState<any>) => {
    setBlock(formState.values);
    log.debug("changed", formState);
  };

  const onCustomAction = async (event: SyntheticEvent): Promise<void> => {
    log.debug("customAction", block);
    event.preventDefault();
    if (block) {
      const id = block.id;
      const originalBlock = treeBlockDataSource.treeStructure.blocks.find(
        (b: BlockObject) => b.id === id
      );
      await customAction.onClick(originalBlock);
      props.handleRefreshBlock();
    }
  };

  const dynamicForm = (formRenderProps: FormRenderProps<any>) => {
    return (
      <SecurityProvider security={{}}>
        <DynamicForm
          {...formRenderProps}
          fields={schema}
          Presentation={FlatForm}
          values={formRenderProps.values}
          model={{}}
          onChange={changed}
        >
          <div className={classes.buttonContainer}>
            {customAction && (
              <Button
                size={"small"}
                variant={"contained"}
                className={classes.button}
                color="primary"
                type={"submit"}
                onClick={onCustomAction}
              >
                {customAction.buttonText()}
              </Button>
            )}

            <Button
              size={"small"}
              variant={"contained"}
              className={classes.button}
              type="submit"
              color="primary"
            >
              {buttonText}
            </Button>
          </div>
        </DynamicForm>
      </SecurityProvider>
    );
  };

  return (
    <DialogContentContainer>
      <Form
        onSubmit={() => submit(block)}
        render={dynamicForm}
        initialValues={block}
      />
    </DialogContentContainer>
  );
});
